import EditButton from "../edit_btn";
import { useNavigate } from "react-router-dom";
import ReactHtmlParser from 'react-html-parser';

export default function EmptySection({ heading, subheading, data, showSummary, setShowSummary }) {
  const navigate = useNavigate();
  return (
    <div class="w-full  p-6 gap-4 rounded-lg bg-[#FFFFFFCC] flex flex-col gap-x-4 shadow-custom">
      <div className="flex justify-between">
        <p class="text-base font-semibold leading-normal text-[#5843BD]">
          {heading}
        </p>
        <EditButton handleClick={() => setShowSummary(true)}/>
      </div>
      {
        data?.About !== undefined && data?.About !== null && data?.About !== "" ? null : ( 
        <p class="text-base font-medium leading-normal text-[#FF6633]">
          {ReactHtmlParser(subheading)}
        </p>
        ) 
      }
      {
        showSummary !== true && (
          <p className=" text-sm font-normal text-[#666666]">
            {data === null ? null : (
              <>{ReactHtmlParser(data?.About)}</>
            )}
          </p>
        )
      }

    </div>

  )
}